import React from 'react';
import ButtonBase from './ButtonBase';
import { TButtonsDefault } from './types/TButtons';

const Secondary = ({ as = 'button', ...rest }: TButtonsDefault) => <ButtonBase {...rest} as={as} kind="secondary" />;

export default Secondary;
